export default __webpack_public_path__ + "static/news-bg-fb0b29041c5e129c56de5599904e564f.png";